import { validatePresenceOf } from '@/shared/utils';

export const validate = mention => {
  return validatePresenceOf(mention, ['registry']);
};

export const buildContent = mention => {
  return mention.registry ? [`${mention.registry}.`] : [];
};
